import React from 'react';
import { styles } from './styles';
import { GridNotificationBox } from "./GridNotificationBox";
export function gridNotificationPlugin(config) {
    return function () {
        return {
            bodyAddons: [
                {
                    id: 'grid-notification',
                    order: -99,
                    render: function () {
                        return React.createElement('div', { className: styles.containerAsOverlay }, React.createElement(GridNotificationBox, {
                            hasClose: !!config.onRequestClose,
                            content: config.content,
                            onRequestClose: config.onRequestClose
                        }));
                    }
                }
            ]
        };
    };
}
//# sourceMappingURL=gridNotificationPlugin.js.map